import gql from 'graphql-tag';

export const updateChargeVerificationConfigMutation = gql`
  mutation updateChargeVerificationConfig(
    $input: UpdateChargeVerificationConfigInput!
  ) {
    updateChargeVerificationConfig(input: $input) {
      channelId
      chargeVerificationEnabled
    }
  }
`;
